import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'poa-required-modal',
  templateUrl: './poa-required-modal.component.html',
  styleUrls: ['./poa-required-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoaRequiredModalComponent {
  @Input() public open: boolean = false;

  @Output() public openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public discard: EventEmitter<void> = new EventEmitter<void>();
  @Output() public goToPoa: EventEmitter<void> = new EventEmitter<void>();

  public onDiscard(): void {
    this.open = false;
    this.openChange.emit(false);
    this.discard.emit();
  }

  public onGoToPoa(): void {
    this.open = false;
    this.openChange.emit(false);
    this.goToPoa.emit();
  }
}
